<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='Tx_OrderPlan_Details' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item txOrderplans">
      <div class="bg-white fh" id='txOrderPlanDetails-table'>
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else-if="item.key === 'planCode'">
                  <a class="link-type"
                     @click.stop="openDrawer(scope.row,'txOrderPlanDetails')">{{ scope.row.planCode }}</a>
                </span>
              <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{
                    scope.row[item.key] | dateFormat
                  }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="txOrderPlanDetails-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData">
      </add-instance>

      <edit-instance ref="editForm" :sourceCode="'Tx_quot'"
                     createdFormId="txOrderPlanDetails-dialog"
                     :visible.sync="dialogEditVisible"
                     :otherSubmitModel="otherSubmitModel"
                     :initData="temp" :soltNameArray="soltNameArray">
        <template slot="venGuid">
          <el-input :value="temp.venName" readonly>
            <el-button slot="append" icon="el-icon-search" @click="()=>{dialogAccessVisible=true}"></el-button>
          </el-input>
        </template>
      </edit-instance>

      <!--转发-->
      <el-dialog class="dialog-mini" width="80%" title="转发" :close-on-click-modal="false"
                 top="44px" :visible.sync="dialogForwardVisible">
        <div class="edit_dialog" style="height: calc(70vh);overflow: auto;">
          <div class="createPost-container">
            <el-form class="form-container">
              <el-form-item label="转发给:">
                <auto-new ref="autoNew"
                          :id.sync="zfform.userid"
                          :name.sync="zfform.username"
                          :idKey="'id'"
                          :nameKey="'name'"
                          :apiName="'Users'"
                          :getDataMethod="'load'"
                ></auto-new>
              </el-form-item>
              <el-table :data="zfform.orderDetail" v-loading="zflistLoading" border fit highlight-current-row
                        style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                        @selection-change="handleSelectionChange" @sort-change="handleSortChange">
                <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
                <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                                 :label="item.description"
                                 :prop="item.key" :align="item.align"
                                 :sortable="item.isSort === true ? 'custom' : false"
                                 :show-overflow-tooltip="item.tooltip">
                  <template slot-scope="scope">
                    <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                                 v-if="item.isSel">
                    </select-type>
                    <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{
                    scope.row[item.key] | dateFormat
                  }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </div>
        </div>
        <div style="text-align:right;" slot="footer">
          <el-button size="small" type="cancel" @click="dialogForwardVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click="SaveTransfer">确定</el-button>
        </div>
      </el-dialog>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>

      <el-dialog class="dialog-mini" top="15vh" v-el-drag-dialog :title="'选择供应商'"
                 :visible.sync="dialogAccessVisible">
        <SelectSupplyInfo ref="SelectSupplyInfo" v-if="dialogAccessVisible" :accGuid="accGuid"
                          @close="dialogAccessVisible=false" @closeMoule="closeMoule"/>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import * as txOrderPlanDetails from '@/api/tx_orderplan_details';
import * as txquot from '@/api/tx_quots';
import mytable from '@/utils/crmtableFlowV2';
import autoNew from '@/components/AutoNew';
import SelectSupplyInfo from '@/components/SelectSupplyInfo';

export default {
  directives: {},
  name: 'txOrderPlanDetails',
  components: {
    autoNew,
    SelectSupplyInfo
  },
  mixins: [mytable],
  data() {
    return {
      zfform: {
        userid: '',
        username: '',
        orderDetail: []
      },
      zflistLoading: false,
      dialogForwardVisible: false,
      crmType: 'Tx_OrderPlan_Detail',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: ''
      },
      dialogAccessVisible: false,
      accGuid: '',
      soltNameArray: ['venGuid'],
      otherSubmitModel: {}
    };
  },
  watch: {},
  created() {
    const _this = this;
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
    this.otherSubmitModel = {
      othersub() {
        return _this.othersub();
      }
    };
  },
  mounted() {
  },
  methods: {
    getApi() {
      if (this.dialogEditVisible) {
        return txquot;
      } else {
        return txOrderPlanDetails;
      }
    },
    othersub() {
      return new Promise((resolve, reject) => {
        const temp = this.$refs[this.dataForm].$refs[this.frmData].GetModelData();
        const now = new Date();
        const time = new Date(temp.finishDate).getTime() - now.getTime();
        if (time < 0) {
          this.$message.error('已超过开标时间，请修改开标时间后重试');
          reject(new Error());
        } else if (new Date(temp.finishDate).toDateString() === now.toDateString()) {
          this.$confirm('距离开标时间不足一天, 是否继续保存?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (temp.directionalInq === '是' && !temp.directionalInstructions) {
              this.$message.error('请填写定向说明');
              reject(new Error());
            } else {
              return resolve(true);
            }
          }).catch(() => {
            reject(new Error());
          });
        } else {
          return resolve(true);
        }
      });
    },
    closeMoule(e) {
      this.$refs.editForm.$refs.frmEditData.AssignmentModel('venGuid', e.map(u => u.id).join(','));
      this.$refs.editForm.$refs.frmEditData.AssignmentModel('venName', e.map(u => u.venName).join(','));
      this.temp.venName = e.map(u => u.venName).join(',');
      this.dialogAccessVisible = false;
    },
    SaveTransfer() {
      if (this.zfform.username && this.zfform.userid) {
        const paramStr = JSON.stringify({
          keyValue: this.zfform.orderDetail.map(item => item.id).join("','"),
          HandleUser: this.zfform.username
        });
        txOrderPlanDetails.SaveTransfer(paramStr).then(res => {
          this.$message({
            message: '转发成功',
            type: 'success'
          });
          this.dialogForwardVisible = false;
          this.getList();
        }).catch((_) => {
          this.dialogForwardVisible = false;
        });
      } else {
        this.$message({
          message: '请选择转发人',
          type: 'error'
        });
      }
    },
    handleCreate() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请最少选择一条记录生成',
          type: 'error'
        });
        return;
      } else {
        txOrderPlanDetails.get(this.multipleSelection.map(u => u.id).join(',')).then(res => {
          this.initData = res.result == null ? {} : res.result;
          this.initData.orderDetail.forEach(item => {
            item.state = '0';
            item.isClose = '0';
          });
          if (this.accList) {
            const tempaccindex = this.accList.findIndex(u => u.accountId === this.initData.AccountId);
            if (tempaccindex > -1) {
              this.initData.handleUser = this.accList[tempaccindex].erpUser;
            }
          }
          this.dialogStatus = 'create';
          this.dialogFormVisible = true;
        }).catch((_) => {
        });
      }
    },
    btnClickOther(bomid) {
      switch (bomid) {
        case 'btnEditnew':
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请最少提交一条记录',
              type: 'error'
            });
            return;
          } else {
            this.Editnew();
          }
          break;
        case 'btnguan':
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          }
          this.guan();
          break;
        case 'btnkai':
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          }
          this.kai();
          break;
        case 'btnchai':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.chai();
          }
          break;
        case 'btnhe':
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          }
          this.he();
          break;
        case 'btnZhuan':
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请最少提交一条记录',
              type: 'error'
            });
            return;
          } else {
            this.Zhuan();
          }
          break;
      }
    },
    Zhuan() {
      this.zflistLoading = true;
      txOrderPlanDetails.GetDetail(this.multipleSelection.map(u => u.id).join(',')).then(res => {
        this.zfform.orderDetail = res.result == null ? {} : res.result;
        this.dialogForwardVisible = true;
        this.zflistLoading = false;
      }).catch((_) => {
        this.zflistLoading = false;
      });
    },
    he() {
      this.$confirm('是否确定合并?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const paramStr = JSON.stringify({
          // 先找到被选择的数据
          // 找到被选择数据的id,转成字符串格式
          keyValue: this.multipleSelection.map(u => u.id).join(',')
        });
        this.listLoading = true;
        txOrderPlanDetails.Concat(paramStr).then(res => {
          this.$message({
            message: '合并成功',
            type: 'success'
          });
          this.getList();
          this.listLoading = false;
        }).catch((_) => {
          this.listLoading = false;
        });
      }).catch(() => {
      });
    },
    Editnew() {
      const paramStr = JSON.stringify({
        // 先找到被选择的数据
        // 找到被选择数据的id,转成字符串格式
        keyValue: this.multipleSelection.map(u => u.id).join(','),
        fromPlan: 1
      });
      txquot.get(paramStr).then(res => {
        this.temp = res.result == null ? {} : res.result;
        this.dialogStatus = 'update';
        this.accGuid = this.temp.orderDetail.map(u => u.accountId).join(',');
        this.dialogEditVisible = true;
      }).catch((_) => {
      });
    },
    guan() {
      this.$confirm('是否确定关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const conforms = this.multipleSelection.filter(u => u.isClose === 0);
        const paramStr = JSON.stringify({
          // 先找到被选择的数据
          // 找到被选择数据的id,转成字符串格式
          keyValue: conforms.map(u => u.id).join(',')
        });
        this.listLoading = true;
        if (conforms && conforms.length > 0) {
          txOrderPlanDetails.Open(paramStr).then(res => {
            this.$message({
              message: '关闭成功',
              type: 'success'
            });
            this.getList();
            this.listLoading = false;
          }).catch((_) => {
            this.listLoading = false;
          });
        } else {
          this.$message({
            message: '请选择行状态为开启的记录!',
            type: 'error'
          });
          this.getList();
        }
      }).catch(() => {
      });
    },
    kai() {
      this.$confirm('是否确定开启?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const conforms = this.multipleSelection.filter(u => u.isClose === 1);
        const paramStr = JSON.stringify({
          // 先找到被选择的数据
          // 找到被选择数据的id,转成字符串格式
          keyValue: conforms.map(u => u.id).join(',')
        });
        this.listLoading = true;
        if (conforms && conforms.length > 0) {
          txOrderPlanDetails.Open(paramStr).then(res => {
            this.$message({
              message: '开启成功',
              type: 'success'
            });
            this.getList();
            this.listLoading = false;
          }).catch((_) => {
            this.listLoading = false;
          });
        } else {
          this.$message({
            message: '请选择行状态为关闭的记录！!',
            type: 'error'
          });
          this.getList();
        }
      }).catch(() => {
      });
    },
    chai() {
      this.$prompt('请输入拆分数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[1-9][0-9]*([\.][0-9]{1,2})?$/,
        inputErrorMessage: '拆分数据格式不正确'
      }).then(({ value }) => {
        const paramStr = JSON.stringify({
          keyValue: this.multipleSelection.map(u => u.id).join(','),
          splitQty: Number(value)
        });
        this.listLoading = true;
        txOrderPlanDetails.Split(paramStr).then(res => {
          this.$message({
            message: '拆分成功',
            type: 'success'
          });
          this.getList();
          this.listLoading = false;
        }).catch((_) => {
          this.listLoading = false;
        });
      }).catch(() => {
      });
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'txOrderPlanDetails') {
        this.getApi().get(row.id).then(res => {
          this.drawertemp = { ...this.drawertemp, ...res.result };
          this.menukeyArray = [
            { name: '', menukey: 'tx_orderplan_detailsview' }
          ]; // 要显示的标签
          this.drawer = true;
        });
      }
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#txOrderPlanDetails-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}
</style>
<style lang="scss">

.user-dialog {
  .el-dialog {
    height: 70%;

    .el-icon-close {
      padding-top: 10px;
    }

    .el-dialog__body {
      height: calc(100% - 35px - 40px);
    }

    .el-dialog__headerbtn {
      top: 0;
    }
  }
}

.txOrderplans .edit_dialog {
  height: calc(100vh - 106px) !important;
  box-sizing: border-box;
}

.txOrderplans .el-dialog {
  margin: 0 !important;
  box-sizing: border-box;
  width: 100% !important;

}

</style>
